module.exports = __webpack_public_path__ + "media/images/claim_profile/Vector-f700f3f043f4216e0753c2597945014e.png";